import { useEffect, useState } from 'react';

export default function useContainerDimensions(myRef) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!myRef.current) return undefined;

    const getDimensions = () => ({
      width: myRef.current.getBoundingClientRect().width,
      height: myRef.current.getBoundingClientRect().height,
    });

    setDimensions(getDimensions());

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myRef]);

  return dimensions;
}
